
import { gql } from 'graphql-request';
import API from 'services/api';

const deleteAsignacion = async (id: number): Promise<boolean> => {
    return await API.graphql(gql`
        mutation {
            deleteAsignacion(
                id: ${id}
            )
        }
    `);
};

export default deleteAsignacion;
